export default "__VITE_ASSET__c56e02de__"